import React from 'react'
// import {Link} from 'react-router-dom'
import './PricingStyles.css'



const btnClick = () => {
    console.log('Im here')
    window.open('https://forms.gle/Y8Yus1wvii1BAx3W7')
  }
  
  const btnClick2 = () => {
    console.log('Im here')
    window.open('https://forms.gle/2bsy24xHi1rPrZGp7')
  }

  const btnClick3 = () => {
    console.log('Im here')
    window.open('https://forms.gle/tXMVpjfbPQ3S7JJ5A')
  }
  const btnClick4 = () => {
    console.log('Im here')
    window.open('https://forms.gle/iom8jQkcyyqySt4c6')
  }
  
  const btnClick5 = () => {
    console.log('Im here')
    window.open('https://forms.gle/h5PyToAhc7bLRXqG6')
  }

  const btnClick6 = () => {
    console.log('Im here')
    window.open('https://forms.gle/PwJqQ6H5Uc9GJRbS8')
  }


const Pricing = () => {
    return (
        <div className='pricing'>
            <div className='card-container'>
            <div className='card'>
                    <h3> General Delegates </h3>
                    <span className='bar'></span>
                    {/* <img src={jpg1} className='img1' alt='' /> */}
                    <p>Ideal for individuals interested in learning about the latest trends, networking with industry professionals, and gaining valuable insights into the African mining sector.</p>
                    <h3>Price: R550</h3>
                    {/* <Link to='https://forms.gle/KEgQLDYjfyMrg9kJ6' className='btn'>Apply</Link> */}
                    <button Class={"btn-sponsor"} onClick={btnClick.bind(this)} >
                Register
              </button>
                </div>
                <div className='card'>
                    <h3> Mine Owner / Lisense / Permit Holder </h3>
                    <span className='bar'></span>
                    {/* <img src={jpg1} className='img1' alt='' /> */}
                    <p>Tailored for individuals involved in mining operations, allowing for deeper discussions on specific challenges and opportunities within the industry.</p>
                    <h3>Price: R850</h3>
                    {/* <Link to='https://forms.gle/KEgQLDYjfyMrg9kJ6' className='btn'>Apply</Link> */}
                    <button className={"btn-sponsor"} onClick={btnClick2.bind(this)} >
                Register
              </button>
                </div>
                <div className='card'>
                    <h3> VIP Delegate </h3>
                    <span className='bar'></span>
                    {/* <img src={jpg1} className='img1' alt='' /> */}
                    <p>Offers exclusive access to VIP networking events, priority seating, and additional benefits, providing a more personalized experience.</p>
                    <h3>Price: R1500</h3>
                    {/* <Link to='https://forms.gle/KEgQLDYjfyMrg9kJ6' className='btn'>Apply</Link> */}
                    <button className={"btn-sponsor"} onClick={btnClick.bind(this)} >
                Register
              </button>
                </div>
                <div className='card'>
                    <h3> VVIP Delegate </h3>
                    <span className='bar'></span>
                    {/* <img src={jpg1} className='img1' alt='' /> */}
                    <p>Provides the highest level of access and benefits, including premium seating, private consultations, and exclusive networking opportunities.</p>
                    <h3>Price: R2500</h3>
                    {/* <Link to='https://forms.gle/KEgQLDYjfyMrg9kJ6' className='btn'>Apply</Link> */}
                    <button className={"btn-sponsor"} onClick={btnClick.bind(this)} >
                Register
              </button>
                </div>
                <div className='card'>
                    <h3> Investor </h3>
                    <span className='bar'></span>
                    {/* <img src={jpg2} className='img2' alt='' /> */}
                    <p> Catered to investors interested in exploring investment opportunities in the African mining sector.</p>
                    <h3>Price: R5000</h3>
                    {/* <Link to='/contact' className='btn'>Apply</Link> */}
                    <button className={"btn-sponsor"} onClick={btnClick3.bind(this)} >
                Register
              </button>
        </div>
                <div className='card'>
                    <h3> Machinery Supplier </h3>
                    <span className='bar'></span>
                   {/* <img src={jpg3} className='img3' alt='' /> */}
                    <p> Offers opportunities to showcase products and services, network with potential clients, and explore business partnerships.</p>
                    <h3>Price: R15 000</h3>  
                    {/* <Link to='/contact' className='btn'>Apply</Link> */}
                    <button className={"btn-sponsor"} onClick={btnClick4.bind(this)} >
                Register
              </button>
                </div>
                <div className='card'>
                    <h3> Commodity Direct Buyer </h3>
                    <span className='bar'></span>
                    {/* <img src={jpg3} className='img3' alt='' /> */}
                    <p> Designed for individuals or companies seeking to purchase mining commodities or equipment.</p>
                    <h3>Price: R5000</h3>
                    {/* <Link to='/contact' className='btn'>Apply</Link> */}
                    <button className={"btn-sponsor"} onClick={btnClick5.bind(this)} >
                Register
              </button>
                </div>
                <div className='card'>
                    <h3> Direct Smelters </h3>
                    <span className='bar'></span>
                    {/* <img src={jpg3} className='img3' alt='' /> */}
                    <p> Connect with mining companies: Secure raw materials and expand your operations.
                    Ideal for: Smelting facilities looking to source materials and increase production.</p>
                    <h3>Price: R9 000</h3>
                    {/* <Link to='/contact' className='btn'>Apply</Link> */}
                    <button className={"btn-sponsor"} onClick={btnClick6.bind(this)} >
                Register
              </button>
                </div>
            </div>
        </div>
    )
}

export default Pricing
